import { LIST_BADGE_LIFECYCLE_STATE } from '@terra/shared-dto-types';
import type { FindingsBulkFilter } from '../clients/testerClient';

export const buildFindingsHeaderTotalFilter = ({
  endpointId,
}: Pick<FindingsBulkFilter, 'endpointId'>): FindingsBulkFilter => ({
  ...(endpointId ? { endpointId } : {}),
  lifecycleState: LIST_BADGE_LIFECYCLE_STATE,
});

const hasExtraFindingsListFilters = (filter: FindingsBulkFilter): boolean =>
  (filter.searchTerm ?? '') !== '' ||
  (filter.severity?.length ?? 0) > 0 ||
  (filter.status?.length ?? 0) > 0 ||
  (filter.category?.length ?? 0) > 0 ||
  filter.isPublished !== undefined ||
  filter.wasAutoPublished !== undefined ||
  filter.hasPrevention !== undefined ||
  filter.hasPendingSeverityChangeRequest !== undefined ||
  filter.createdStartDate !== undefined ||
  filter.createdEndDate !== undefined ||
  filter.discoveryStartDate !== undefined ||
  filter.discoveryEndDate !== undefined;

export const needsUnfilteredFindingsTotal = (
  filter: FindingsBulkFilter,
): boolean =>
  hasExtraFindingsListFilters(filter) ||
  (filter.lifecycleState ?? LIST_BADGE_LIFECYCLE_STATE) !==
    LIST_BADGE_LIFECYCLE_STATE;
